import { useDispatch } from "react-redux";
import { Img, Text, Flex, Skeleton } from "@chakra-ui/react";

import IsDoctor from "../permission/isDoctor";

import Quantity from "./quantity";
import Delete from "../../../src/assets/svg/delete";
import { removeFromCart } from "../../redux/actions";

export default function CartItemMob({ product }) {
  const dispatch = useDispatch();
  const { id, name, image, price, quantity, doctorPrice } = product;

  const productSubTotal =
    quantity * (IsDoctor() ? parseFloat(doctorPrice) : parseFloat(price));

  return (
    <Flex
      p="4"
      mb="30px"
      width="100%"
      borderWidth={2}
      flexDirection="column"
      d={{ base: "flex", md: "none" }}
    >
      <Flex width="100%" justifyContent="flex-end" mb="4">
        <Delete
          height="20"
          width="20"
          color="#49586B"
          onClick={() => dispatch(removeFromCart(id))}
        />
      </Flex>
      <Img
        bg="light"
        lazy="true"
        width="100%"
        height="200px"
        src={image.src}
        overflow="hidden"
        alt="product-image"
        objectFit="contain"
        fallback={<Skeleton w="100%" />}
      />

      <Flex width="100%" justifyContent="space-between" pt="4">
        <Text variant="cartBold">Product</Text>
        <Text variant="cartBold">{name}</Text>
      </Flex>
      <Flex width="100%" justifyContent="space-between" pt="4">
        <Text variant="cartBold">Price</Text>
        <Text variant="cartRegular">
          ₹
          {IsDoctor()
            ? parseFloat(doctorPrice).toFixed(2)
            : parseFloat(price).toFixed(2)}
        </Text>
      </Flex>
      <Flex width="100%" justifyContent="space-between" pt="4">
        <Text variant="cartBold">Quantity</Text>
        <Quantity id={id} quantity={quantity} />
      </Flex>
      <Flex width="100%" justifyContent="space-between" pt="4">
        <Text variant="cartBold">Subtotal</Text>
        <Text variant="cartRegular">₹{productSubTotal.toFixed(2)}</Text>
      </Flex>
    </Flex>
  );
}
